var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.187198 6.5L1.0661 6.5C1.12587 6.5 1.18212 6.4707 1.21728 6.42266L4.54657 1.83359L7.87587 6.42266C7.91103 6.4707 7.96728 6.5 8.02704 6.5L8.90595 6.5C8.98212 6.5 9.02665 6.41328 8.98212 6.35117L4.85009 0.654687C4.70009 0.448437 4.39306 0.448437 4.24423 0.654687L0.112198 6.35117C0.0664945 6.41328 0.111026 6.5 0.187198 6.5V6.5Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret_up.f6a7cf6da3b9191144ddb7f848a8d4cf.svg";
export { ForwardRef as ReactComponent };